import * as PropTypes from 'prop-types';
import * as React from 'react';
import { MobileDetection } from '@reverbdotcom/discovery-ui';

class HideableSlider extends React.Component {
  get buttonLabel() {
    if (this.shouldRenderSlider) { return I18n.t('js.bump.hideSlider'); }

    return this.props.label;
  }

  get buttonClass() {
    if (!this.shouldRenderSlider) {
      return 'button button--orange mt-1';
    }

    return 'button mt-1';
  }

  get isMobile() {
    return MobileDetection.isMobileBrowser();
  }

  get shouldRenderSlider() {
    if (!this.isMobile) { return true; }

    return this.props.showMobileSlider;
  }

  renderSlider() {
    if (!this.shouldRenderSlider) { return null; }

    return this.props.children;
  }

  renderCurrentBid() {
    if (!this.props.currentBid || this.shouldRenderSlider) { return null; }
    return (
      <h4 className="weight-bold scaling-mtb-1">
        {I18n.t(
'js.bump.change.currentBid',
          { bidPercent: (parseFloat(this.props.currentBid) * 100).toFixed(1) },
        )}
      </h4>
    );
  }

  renderSliderButton() {
    if (!this.isMobile) { return null; }

    return (
      <div className="align-center">
        {this.renderCurrentBid()}
        <button
          className={this.buttonClass}
          onClick={() => this.props.sliderToggle()}
        >
          {this.buttonLabel}
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSlider()}
        {this.renderSliderButton()}
      </div>
    );
  }
}

HideableSlider.propTypes = {
  currentBid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  sliderToggle: PropTypes.func.isRequired,
  showMobileSlider: PropTypes.bool.isRequired,
  children: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
};

export default HideableSlider;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/hideable_slider.jsx